import type { ReactNode } from 'react'

import * as styles from './breadcrumbs.styles'

type Props = {
  children: ReactNode
}

export const Breadcrumbs = ({ children }: Props) => (
  <nav aria-label="Breadcrumbs" css={styles.nav}>
    <ol css={styles.list}>{children}</ol>
  </nav>
)
